/* eslint-disable react-hooks/rules-of-hooks */
import 'app/components/PACSConfiguration/style.scss';

import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Label } from 'semantic-ui-react';
import { useForm } from 'react-hook-form';

import AETitleSelector from 'app/components/PACSConfiguration/AETitleSelector';
import ControlledLabeledCheckbox from 'app/ReactUseForm/ControlledLabeledCheckbox';
import WorklistIntervalInput from 'app/components/PACSConfiguration/WorklistIntervalInput';
import PACSCommunicationInjector from 'app/injectors/PACSCommunication/context';
import { WMConfiguration } from 'app/dicom/WorklistMonitor';
import { selectPACSConfiguration, updatePACSWorklist } from 'app/redux/PACSConfiguration/reducer';

export default function PACSWorklistConfiguration() {
  const PACSCommunicationCtor = useContext(PACSCommunicationInjector);
  if (!PACSCommunicationCtor) return null;

  const pacsConfiguration = useSelector(selectPACSConfiguration);
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);

  const worklistValues = useMemo(() => {
    return {
      interval:
        pacsConfiguration?.worklist?.interval !== undefined
          ? pacsConfiguration.worklist.interval
          : 5 * 60,
      isEnabled: pacsConfiguration?.worklist?.isEnabled ?? false,
      aeTitles: pacsConfiguration?.worklist?.aeTitles ?? undefined,
    };
  }, [pacsConfiguration?.worklist]);

  const { control, watch } = useForm<{ worklist: WMConfiguration }>({
    values: {
      worklist: worklistValues,
    },
    resetOptions: { keepDirtyValues: true },
    mode: 'onChange',
  });

  const rules = {
    interval: { min: 1 },
  } as const;

  const worklist = watch('worklist');

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    dispatch(updatePACSWorklist({ ...worklist }));
  }, [...Object.values(worklist)]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Form className="pacs-configuration">
      <div className="pacs-configuration__fields">
        <div>
          <Form.Field as="label">
            <div className="ui labeled input">
              <Label>
                <FormattedMessage id="pacs.configuration.worklist.aetitle" />
              </Label>
              <AETitleSelector control={control} name="worklist.aeTitles" />
            </div>
          </Form.Field>
          <WorklistIntervalInput
            control={control}
            name="worklist.interval"
            rules={rules.interval}
            label={<FormattedMessage id="pacs.configuration.worklist.interval" />}
            fluid
            id="pacs.configuration.worklist.interval"
            type="number"
          />
          <ControlledLabeledCheckbox
            control={control}
            name="worklist.isEnabled"
            label={<FormattedMessage id="pacs.configuration.worklist.isenabled" />}
            toggle
          />
        </div>
        <div />
      </div>
    </Form>
  );
}
